import {useEffect} from 'react'

export default (title: string | null | undefined) => {
  useEffect(() => {
    if (title == null) {
      return undefined
    }

    const originalTitle = document.title
    document.title = title
    return () => {
      document.title = originalTitle
    }
  }, [title])
}
